<h3 id="heading" style="margin-left: 10px;">Select Mounting Position<span class="close-btn" (click)="closePopup()" style="float: right;
    margin: 10px;
    font-size: 20px;
    font-weight: normal;
    cursor: pointer;
    ">X</span></h3>
    <div id="assembly1" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/-1-.png'" (click)="selectImage('-1-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/C1-.png'" (click)="selectImage('C1-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/W1-.png'" (click)="selectImage('W1-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/X1-.png'" (click)="selectImage('X1-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/Y1-.png'" (click)="selectImage('Y1-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/Z1-.png'" (click)="selectImage('Z1-')" />
                </div>
            </div>
            <br>
        </div>
    </div>


    <!-- Assembly2 -->
    <div id="assembly2" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/-2-.png'" (click)="selectImage('-2-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/C2-.png'" (click)="selectImage('C2-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/W2-.png'" (click)="selectImage('W2-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/X2-.png'" (click)="selectImage('X2-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/Y2-.png'" (click)="selectImage('Y2-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/Z2-.png'" (click)="selectImage('Z2-')" />
                </div>
            </div>
            <br>
        </div>
    </div>

     <!-- Assembly3 -->
     <div id="assembly3" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/-3-.png'" (click)="selectImage('-3-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/C3-.png'" (click)="selectImage('C3-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/W3-.png'" (click)="selectImage('W3-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/X3-.png'" (click)="selectImage('X3-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/Y3-.png'" (click)="selectImage('Y3-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/Z3-.png'" (click)="selectImage('Z3-')" />
                </div>
            </div>
            <br>
        </div>
    </div>


    <!-- Assembly4 -->
    <div id="assembly4" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/-4-.png'" (click)="selectImage('-4-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/C4-.png'" (click)="selectImage('C4-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/W4-.png'" (click)="selectImage('W4-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/X4-.png'" (click)="selectImage('X4-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/Y4-.png'" (click)="selectImage('Y4-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/Z4-.png'" (click)="selectImage('Z4-')" />
                </div>
            </div>
            <br>
        </div>
    </div>


    <!-- Assembly5 -->
    <div id="assembly5" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/-5-.png'" (click)="selectImage('-5-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/C5-.png'" (click)="selectImage('C5-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/W5-.png'" (click)="selectImage('W5-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/X5-.png'" (click)="selectImage('X5-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/Y5-.png'" (click)="selectImage('Y5-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/Z5-.png'" (click)="selectImage('Z5-')" />
                </div>
            </div>
            <br>
        </div>
    </div>


    <!-- Assembly6 -->
    <div id="assembly6" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/-6-.png'" (click)="selectImage('-6-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/C6-.png'" (click)="selectImage('C6-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/W6-.png'" (click)="selectImage('W6-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/X6-.png'" (click)="selectImage('X6-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/Y6-.png'" (click)="selectImage('Y6-')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HO/Z6-.png'" (click)="selectImage('Z6-')" />
                </div>
            </div>
            <br>
        </div>
    </div>



    <!-- Assembly7A -->
    <div id="assembly7a" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/-7A.png'" (click)="selectImage('-7A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/C7A.png'" (click)="selectImage('C7A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/W7A.png'" (click)="selectImage('W7A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/X7A.png'" (click)="selectImage('X7A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Y7A.png'" (click)="selectImage('Y7A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Z7A.png'" (click)="selectImage('Z7A')" />
                </div>
            </div>
            <br>
        </div>
    </div>

    <!-- Assembly8A -->
    <div id="assembly8a" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/-8A.png'" (click)="selectImage('-8A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/C8A.png'" (click)="selectImage('C8A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/W8A.png'" (click)="selectImage('W8A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/X8A.png'" (click)="selectImage('X8A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Y8A.png'" (click)="selectImage('Y8A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Z8A.png'" (click)="selectImage('Z8A')" />
                </div>
            </div>
            <br>
        </div>
    </div>

    <!-- Assembly9A -->
    <div id="assembly9a" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/-9A.png'" (click)="selectImage('-9A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/C9A.png'" (click)="selectImage('C9A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/W9A.png'" (click)="selectImage('W9A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/X9A.png'" (click)="selectImage('X9A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Y9A.png'" (click)="selectImage('Y9A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Z9A.png'" (click)="selectImage('Z9A')" />
                </div>
            </div>
            <br>
        </div>
    </div>

    <!-- Assembly0A -->
    <div id="assembly0a" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/-0A.png'" (click)="selectImage('-0A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/C0A.png'" (click)="selectImage('C0A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/W0A.png'" (click)="selectImage('W0A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/X0A.png'" (click)="selectImage('X0A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Y0A.png'" (click)="selectImage('Y0A')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Z0A.png'" (click)="selectImage('Z0A')" />
                </div>
            </div>
            <br>
        </div>
    </div>


    <!-- Assembly7B -->
    <div id="assembly7b" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/-7A.png'" (click)="selectImage('-7B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/C7A.png'" (click)="selectImage('C7B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/W7A.png'" (click)="selectImage('W7B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/X7A.png'" (click)="selectImage('X7B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Y7A.png'" (click)="selectImage('Y7B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Z7A.png'" (click)="selectImage('Z7B')" />
                </div>
            </div>
            <br>
        </div>
    </div>


    <!-- Assembly8B -->
    <div id="assembly8b" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/-8A.png'" (click)="selectImage('-8B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/C8A.png'" (click)="selectImage('C8B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/W8A.png'" (click)="selectImage('W8B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/X8A.png'" (click)="selectImage('X8B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Y8A.png'" (click)="selectImage('Y8B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Z8A.png'" (click)="selectImage('Z8B')" />
                </div>
            </div>
            <br>
        </div>
    </div>

    <!-- Assembly9B -->
    <div id="assembly9b" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/-9A.png'" (click)="selectImage('-9B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/C9A.png'" (click)="selectImage('C9B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/W9A.png'" (click)="selectImage('W9B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/X9A.png'" (click)="selectImage('X9B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Y9A.png'" (click)="selectImage('Y9B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Z9A.png'" (click)="selectImage('Z9B')" />
                </div>
            </div>
            <br>
        </div>
    </div>

    <!-- Assembly0B -->
    <div id="assembly0b" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/-0A.png'" (click)="selectImage('-0B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/C0A.png'" (click)="selectImage('C0B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/W0A.png'" (click)="selectImage('W0B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/X0A.png'" (click)="selectImage('X0B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Y0A.png'" (click)="selectImage('Y0B')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Z0A.png'" (click)="selectImage('Z0B')" />
                </div>
            </div>
            <br>
        </div>
    </div>


    <!-- Assembly0C -->
    <div id="assembly0c" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/-0A.png'" (click)="selectImage('-0C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/C0A.png'" (click)="selectImage('C0C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/W0A.png'" (click)="selectImage('W0C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/X0A.png'" (click)="selectImage('X0C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Y0A.png'" (click)="selectImage('Y0C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Z0A.png'" (click)="selectImage('Z0C')" />
                </div>
            </div>
            <br>
        </div>
    </div>


    <!-- Assembly7C -->
    <div id="assembly7c" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/-7A.png'" (click)="selectImage('-7C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/C7A.png'" (click)="selectImage('C7C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/W7A.png'" (click)="selectImage('W7C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/X7A.png'" (click)="selectImage('X7C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Y7A.png'" (click)="selectImage('Y7C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Z7A.png'" (click)="selectImage('Z7C')" />
                </div>
            </div>
            <br>
        </div>
    </div>


    <!-- Assembly8C -->
    <div id="assembly8c" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/-8A.png'" (click)="selectImage('-8C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/C8A.png'" (click)="selectImage('C8C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/W8A.png'" (click)="selectImage('W8C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/X8A.png'" (click)="selectImage('X8C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Y8A.png'" (click)="selectImage('Y8C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Z8A.png'" (click)="selectImage('Z8C')" />
                </div>
            </div>
            <br>
        </div>
    </div>

    <!-- Assembly9C -->
    <div id="assembly9c" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/-9A.png'" (click)="selectImage('-9C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/C9A.png'" (click)="selectImage('C9C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/W9A.png'" (click)="selectImage('W9C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/X9A.png'" (click)="selectImage('X9C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Y9A.png'" (click)="selectImage('Y9C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Z9A.png'" (click)="selectImage('Z9C')" />
                </div>
            </div>
            <br>
        </div>
    </div>

    <!-- Assembly0C -->
    <div id="assembly0c" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/-0A.png'" (click)="selectImage('-0C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/C0A.png'" (click)="selectImage('C0C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/W0A.png'" (click)="selectImage('W0C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/X0A.png'" (click)="selectImage('X0C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Y0A.png'" (click)="selectImage('Y0C')" />
                </div>
            </div>
            <br>
            <div class="row">
                <div>
                    <img class="img-thumbnail" alt="test" [src]=" AssetbasePath + '/Content/HPImages/Mounting/HV/Z0A.png'" (click)="selectImage('Z0C')" />
                </div>
            </div>
            <br>
        </div>
    </div>